import { actionType } from "../../helpers/reducers";

/*
  Document is an over arching concept. Document contains one or more pages. Pages in way can be thought of as chapters
 */

// Documents
export const DOC_SET = "doc/SET";
export const DOC_CLEAR = "doc/CLEAR";
export const DOC_REMOVE = "doc/REMOVE";
export const DOC_SET_MULTIPLE = "doc/SET_MULTIPLE";

export const setDoc = actionType(DOC_SET);

// API
export const DOC_FETCH = "doc/FETCH";
export const DOC_FETCH_ALL = "doc/FETCH_ALL";
export const DOC_SAVE = "doc/SAVE";
export const DOC_CREATE = "doc/CREATE";
export const DOC_DESTROY = "doc/DESTROY";

export const fetchDoc = actionType(DOC_FETCH);
export const fetchDocs = actionType(DOC_FETCH_ALL);
export const createDoc = actionType(DOC_CREATE);
export const saveDoc = actionType(DOC_SAVE);
export const destroyDoc = actionType(DOC_DESTROY);
